import React from 'react';

import { useAuth } from '../../../../../../shared/hooks';
import { CreatorList as SharedCreatorList } from '../../../../../shared/components/Filter';
import { useFilters, useResources } from '../../../hooks';

const CreatorList = () => {
  const {
    user: { id: currentUserId },
  } = useAuth();

  const { activeFilters, toggleFilter } = useFilters();
  const { users } = useResources();

  return (
    <SharedCreatorList
      currentUserId={currentUserId}
      onToggle={(value) => toggleFilter({ type: 'creators', value })}
      selectedIds={activeFilters.creators}
      users={users}
    />
  );
};

export default CreatorList;
